import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Tea",
  "description": "",
  "published": "2007-04-27T00:00:00.000Z",
  "redirect_from": ["/blog/tea/swizec/225"],
  "categories": "funny, life, linkages",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Well this post was supposed to go up last night but I somehow managed to fall asleep watching Sherlock Holmes before the water for tea boiled. Go figure.`}</p>
    <p>{`Anyway, an interview was filmed with me yesterday and even though it was the first such thing to happen to me, I had quite some fun doing it. It was nothing of the professional sort as was apparent by the whole lack of preparation of both parties and that I somehow wasn't allowed to go into long rambles, which I'd like, but maybe they just weren't eloquent enough. I should really work on my speaking eloquency ... When I get it the interview goes up on youtube of course.`}</p>
    <p>{`Because I feel like it here is also a `}<a parentName="p" {...{
        "href": "http://flickr.com/photos/7280946@N06/474283871/"
      }}>{`panoramic shot`}</a>{` of my favourite tea house that feeds me tea nigh on every day.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      